// ModalItemInspecaoFrotaCadastro.tsx

import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from "primereact/dropdown";
import { Button } from 'primereact/button';
import { Label } from 'components/input/Label';
import { useForm } from 'react-hook-form';
import ItemInspecaoFrota from 'model/gestao/frotas/ItemInspecaoFrota';
import ManutencaoVeiculoService from 'service/gestao/frotas/ManutencaoVeiculoService';
import VeiculoItemInspecao from 'model/gestao/frotas/VeiculoItemInspecao';
import Veiculo from 'model/gestao/frotas/Veiculo';

interface ModalItemInspecaoFrotaCadastroProps {
    visible: boolean;
    onHide: () => void;
    onSave: (item: VeiculoItemInspecao) => void;
    novoItem: VeiculoItemInspecao | null;
    veiculo: Veiculo | null;
}

export default function ModalItemInspecaoFrotaCadastro(props: ModalItemInspecaoFrotaCadastroProps) {

    const [veiculoItemInspecao, setVeiculoItemInspecao] = useState<VeiculoItemInspecao>(new VeiculoItemInspecao());
    const { setError, formState: { errors }, register, clearErrors } = useForm();
    const manutencaoVeiculoService = new ManutencaoVeiculoService();

    const validar = () => {
        if (!veiculoItemInspecao.itemInspecao.nome) {
            setError("nome", { type: "manual", message: "Nome é obrigatório" }, { shouldFocus: true });
            return false;
        }
        return true;
    };

    const handleSave = async () => {
        if (validar()) {
            manutencaoVeiculoService.salvarNovoVeiculoItemInspecao(veiculoItemInspecao).then((data) => {
                props.onSave(data);
            }).catch((erro) => {
                console.error(erro);
            })
        }
    };

    return (
        <Dialog
            header="Adicionar Novo Item de Inspeção"
            visible={props.visible}
            style={{ width: '50vw' }}
            onHide={props.onHide}
            onShow={() => {
                setVeiculoItemInspecao({...veiculoItemInspecao, veiculo: props.veiculo});
            }}
            modal
        >
            <div>
                <div className="row">
                    <Label className="col col-sm-12" obrigatorio>Nome</Label>
                    <div className="col-sm-12">
                        <InputText required value={veiculoItemInspecao.itemInspecao.nome} maxLength={100} style={{ width: '30%' }}
                            className={errors.nome ? "p-invalid" : ""}
                            {...register("nome", {
                                onChange: (e) => {
                                    clearErrors("nome");
                                    setVeiculoItemInspecao({
                                        ...veiculoItemInspecao,
                                        itemInspecao: {
                                            ...veiculoItemInspecao.itemInspecao,
                                            nome: e.target.value,
                                        },
                                    });
                                }
                            })}
                        />
                    </div>
                    {errors.nome && errors.nome.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.nome?.message as string}</span> : null}
                </div>

                <div className='row'>
                    <Label className="col col-sm-12">Descrição Inspeção</Label>
                    <div className="col-sm-12">
                        <InputText required value={veiculoItemInspecao.descricao ? veiculoItemInspecao.descricao : ""} maxLength={100} style={{ width: '30%' }}
                            onChange={(e) => setVeiculoItemInspecao({ ...veiculoItemInspecao, descricao: e.target.value })}
                        />
                    </div>
                </div>

                <div className="row">
                    <Label className="col col-sm-12">Periodicidade Revisão</Label>
                    <div className="col-sm-12">
                        <InputNumber value={veiculoItemInspecao.vlPeriodicidadeRevisao} onChange={(e) => setVeiculoItemInspecao({ ...veiculoItemInspecao, vlPeriodicidadeRevisao: e.value })}
                            locale='pt-BR' useGrouping={false}
                            style={{ width: '15%', marginRight: '10%' }}
                        />
                        <Dropdown
                            options={[{ label: 'Dias', value: 'DIAS' }, { label: 'Meses', value: 'MESES' }, { label: 'Anos', value: 'ANOS' }]}
                            optionValue='value'
                            optionLabel='label'
                            value={veiculoItemInspecao.periodicidade}
                            onChange={(e) => setVeiculoItemInspecao({ ...veiculoItemInspecao, periodicidade: e.target.value })}
                            style={{ width: '14%' }} />
                    </div>
                </div>

                <div className="row">
                    <Label className="col col-sm-12">Intervalo Quilometragem Revisão</Label>
                    <div className="col-sm-12">
                        <InputNumber value={veiculoItemInspecao.intervaloQuilometragemRevisao} onChange={(e) => setVeiculoItemInspecao({ ...veiculoItemInspecao, intervaloQuilometragemRevisao: e.value })}
                            locale='pt-BR' useGrouping={false}
                            style={{ width: '30%' }}
                        />
                    </div>
                </div>

                <div className="row">
                    <Label className="col col-sm-12">Intervalo Horas Revisão</Label>
                    <div className="col-sm-12">
                        <InputNumber value={veiculoItemInspecao.intervaloHorasRevisao} onChange={(e) => setVeiculoItemInspecao({ ...veiculoItemInspecao, intervaloHorasRevisao: e.value })}
                            style={{ width: '30%' }}
                            locale='pt-BR' useGrouping={false}
                        />
                    </div>
                </div>


                <div className="row" >
                    <div className='col-sm-12' style={{ marginTop: '1rem', textAlign: 'right', whiteSpace: 'nowrap' }}>
                        <Button label="Cancelar" icon="pi pi-times" onClick={props.onHide} className="p-button-text" />
                        <Button label="Salvar" icon="pi pi-check" onClick={handleSave} autoFocus style={{ marginLeft: 8 }} />
                    </div>
                </div>
            </div>
        </Dialog>
    );
}
